const rankingItems = [
  { rank: 1, title: '暗夜追踪', type: '悬疑剧集', score: '9.2', trend: 'up', color: 'bg-primary-500 text-background-50' },
  { rank: 2, title: '锦绣浮生', type: '古装大剧', score: '9.0', trend: 'up', color: 'bg-primary-400 text-background-50' },
  { rank: 3, title: '心动频率', type: '甜宠爱情', score: '8.9', trend: 'up', color: 'bg-accent-500 text-background-50' },
  { rank: 4, title: '极限营救', type: '动作大片', score: '8.7', trend: 'new', color: 'bg-foreground-400 text-background-50' },
  { rank: 5, title: '灵笼 第二季', type: '国产动漫', score: '8.6', trend: 'up', color: 'bg-foreground-400 text-background-50' },
  { rank: 6, title: '喜剧大会', type: '热门综艺', score: '8.5', trend: 'up', color: 'bg-foreground-400 text-background-50' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 mb-2">
          热门榜单
        </h2>
        <p className="text-sm text-foreground-500 mb-8 font-body">全网热播影视排行，大家都在看这些</p>
        <div className="max-w-2xl mx-auto flex flex-col gap-2">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-heading font-extrabold shrink-0 ${item.color}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 whitespace-nowrap">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 font-body">{item.type}</p>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="text-sm font-heading font-bold text-primary-600">{item.score}</span>
                <span className={`text-xs font-label ${item.trend === 'up' ? 'text-green-600' : item.trend === 'new' ? 'text-accent-600' : 'text-foreground-500'}`}>
                  {item.trend === 'up' ? '↑' : item.trend === 'new' ? 'NEW' : '—'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}